import rawColumnsData from "../../components/Nhf/Compound/editor/rawColumns"
import nutColumnsData from "../../components/Nhf/Compound/editor/nutColumns"

import RawEditorColumnsArr from '../../components/Nhf/Blend/editor/RawEditorColumns'
import RawEditor2ColumnsArr from '../../components/Nhf/Blend/editor/RawEditor2Columns'
import NutritionEditorArr from '../../components/Nhf/Blend/editor/NutritionColumns'
import NutritionArr from '../../components/Nhf/Blend/editor/Nutrition'
// Nutrition.js

// const RawEditor = window.localStorage.getItem("RawEditor");
// const RawEditor2 = window.localStorage.getItem('RawEditor2')
// const NutritionEditorArr = window.localStorage.getItem('NutritionEditor')
// const NutritionArr = window.localStorage.getItem('NutritionEditor')

import {setStoreageColumns,setColumnsFilter,setColumnsStrFilter} from '../utils'
const nutTableColShow = [ "nutritionName", "content", "unit", "productContent", "minValue", "maxValue", "cost", "minApply",  "maxApply"]
// 默认隐藏“变化”(ptcArrowFlag)列，由用户在列选择中勾选
const rawTableColShow  = [ "rawName",  "rawCode", "price","percentage", 'productRawPercentage', "minValue", "maxValue", "minShadowPrice", "maxShadowPrice", "cost",  "minApply","maxApply",]
const rawEditorShow = ['rawCode','price','uasge','percentage','minValue','maxValue','cost','minShadowPrice','maxShadowPrice','minApply','maxApply']
const rawEditor2Show = ['rawCode','price','uasge','percentage','minValue','maxValue','cost','minShadowPrice','maxShadowPrice','minApply','maxApply','mixPercentage']


const NutritionEditorShow = ['unit','content','minValue','maxValue','cost','minApply','maxApply']
const NutritionShow = ['unit','content','minValue','maxValue','cost','minApply','maxApply']

const nhf = {
  namespaced: true,
  state: () => ({
    nutritionList:[],
    animalGroups: [], // 添加动物分组数据
    layout: {
      showSider: false,
      showRight: false,
      layoutType: false,
    },
    visible: {
      raw: false,
      nut: false,
      nut2: false,
      result: false,
      result2: false,
      nutChoose: false,
      raw2: false,
      saveRaw:false,
      estimated: false,
      nhfEstimateData: {},
      vision: false,
      saveModal: false,
      loadingModal: false,
      closeFormula: false
    },
    getListFlag: 0,
    rawTypeSelect: 0,
    indexFilter: 0,
    rawColumns:setStoreageColumns('rawTableColumns',rawColumnsData),
    nutColumns:setStoreageColumns('nutTableColumns',nutColumnsData),
    rawTableColShow: setColumnsFilter('rawTableColShow',rawTableColShow),
    nutTableColShow: setColumnsFilter('nutTableColShow',nutTableColShow),
    RawEditorColumnsArr,


    rawEditorsColumns: setStoreageColumns('RawEditorColumnsArr',RawEditorColumnsArr),
    rawEditors2Columns: setStoreageColumns('RawEditor2ColumnsArr',RawEditor2ColumnsArr),
    // rawEditors: RawEditor ? JSON.parse(RawEditor):['rawName'],
    // rawEditors2: RawEditor2 ? JSON.parse(RawEditor2):['rawName'],
    rawEditors: setColumnsStrFilter('RawEditor',rawEditorShow),
    rawEditors2: setColumnsStrFilter('RawEditor2',rawEditor2Show),

    NutritionEditorArr: setStoreageColumns('NutritionEditors',NutritionEditorArr),
    NutritionArr: setStoreageColumns('Nutritions',NutritionArr),
    nutritionEditor: setColumnsStrFilter('NutritionEditor',NutritionEditorShow),
    nutritions: setColumnsStrFilter('Nutrition',NutritionShow),
    // 配方详情
    detail: {
      nutritionName: "",
      lastPrice: 0,
      price: 0,
    },
    height: 0,
    leftBoxTopHeight: 500,
    leftBoxBottomHeight: 500,
    nutSelect: {},
    rawSelect: { rawName: "", percentage: 0 },
    rawRows: [],
    nutRows: [],
    rawResult: [], // 计算结果
    nutVisible: false,
    calculaVisible: false,
    rightWidth: 1000, // 可拖拽框右侧宽度
    leftWidth: 1000, // 可拖拽框左侧宽度
    getVisionRaw: {}, // 获取版本存储行数据
    referPriceSourceChange: false,
    priceSourceChange:  false,
    setClassVisible: false,
    ishandle: false,
  }),
  mutations: {
    toggleLayout(state, action) {
      let {feild,val} = action || {}
      state.layout[feild] = val
      if(val){
        window.localStorage.setItem([feild],feild)
      }else{
        if(feild === 'showSider' || feild === 'showRight'){
          window.localStorage.setItem(feild,'setFalse')
        }else if(feild === 'layoutType'){
          window.localStorage.setItem('layoutType',false)
        }
        
      }
      // if(action){
      //   if(action !== 'setFalse'){
      //     state.layout[action] = true
      //   }
      // }else{
        // if(state.layout[action]){
        //   if(action === 'showSider' || action === 'showRight'){
        //     let s = window.localStorage.getItem(action)
        //     if(s === action){
        //       window.localStorage.setItem([action],s)
        //     }else{
        //       window.localStorage.setItem([action],'setFalse')
        //     }
        //   }else{
        //     console.log('sss',action)
        //     window.localStorage.removeItem(action)
        //   }
        // }else{
        //   if(action !== 'setFalse') window.localStorage.setItem([action],action)
        // }
        // state.layout[action] = !state.layout[action]
      // }
    },
    toggleVisible(state, name) {
      let status = {}
      status[name] = !state.visible[name];
      state.visible = { ...state.visible, ...status }
    },
    setState(state, payload) {
      for (let i in payload) {
        state[i] = payload[i]
      }
    },
    // 添加设置动物分组数据的 mutation
    setAnimalGroups(state, animalGroups) {
      state.animalGroups = animalGroups;
    },
  },
  getters: {
    rawColumnsValue: (state) => {
      const { rawTableColShow,rawColumns } = state
      return rawColumns.filter((item) => rawTableColShow.includes(item.dataIndex))
    },
    nutColumnsValue: (state) => {
      const { nutTableColShow,nutColumns } = state
      return nutColumns.filter((item) => nutTableColShow.includes(item.dataIndex))
    },
    
    rawEditorColumns: (state) => {
      const { rawEditors ,rawEditorsColumns} = state;
      if(!rawEditors.includes('rawName')) rawEditors.push('rawName')
      return rawEditorsColumns.filter((item) => {
        return rawEditors.includes(item.dataIndex)
      });
    },
    rawEditor2Columns: (state) => {
      const { rawEditors2 ,rawEditors2Columns} = state;
      if(!rawEditors2.includes('rawName')) rawEditors2.push('rawName')
      return rawEditors2Columns.filter((item) => {
        return rawEditors2.includes(item.dataIndex)
      });
    },
    nutritionEditorColumns: (state) => {
      const { nutritionEditor,NutritionEditorArr } = state;
      if(!nutritionEditor.includes('nutritionName')) nutritionEditor.push('nutritionName')
      return NutritionEditorArr.filter((item) => {
        return nutritionEditor.includes(item.dataIndex)
      });
    },
    nutritionColumns: (state) => {
      const { nutritions,NutritionArr } = state;
      if(!nutritions.includes('nutritionName')) nutritions.push('nutritionName')
      return NutritionArr.filter((item) => {
        return nutritions.includes(item.dataIndex)
      });
    },
  },
}
export default nhf
